import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M480-100.001q-70.769 0-132.615-26.77-61.846-26.769-107.846-72.768-45.999-46-72.768-107.846-26.77-61.846-26.77-132.615H200q0 117 81.5 198.5T480-160q117 0 198.5-81.5T760-440q0-117-81.5-198.5T480-720h-10.616l63.539 63.539-42.153 43.383-136.921-137.306 137.69-137.306 42.153 43.384-64.308 64.307H480q70.769 0 132.615 26.77 61.846 26.769 107.846 72.768 45.999 46 72.768 107.846 26.77 61.846 26.77 132.615t-26.77 132.615q-26.769 61.846-72.768 107.846-46 45.999-107.846 72.768-61.846 26.77-132.615 26.77z"
      ></path>
    </svg>
  );
}

export default Icon;
